// // IMPORT ICONS
// import adhd from '../../assets/track_icons/ADHD.webp';
// import community_nursing from '../../assets/track_icons/community_nursing.webp';
// import emergency_trauma_nursing from '../../assets/track_icons/emergency&trauma_nursing.webp';
// import geriatric_nursing from '../../assets/track_icons/geriatric_nursing.webp';
// import neonatal_nursing from '../../assets/track_icons/neonatal_nursing.webp';
// import oncology_cancer_care from '../../assets/track_icons/oncology&Cancer_care.webp';
// import pediatric_nursing from '../../assets/track_icons/pediatric_nursing.webp';
// import autism from '../../assets/track_icons/Autism.webp';
// import critical_care_nursing from '../../assets/track_icons/critical_care_nursing.webp';
// import epidemiology from '../../assets/track_icons/Epidemiology.webp';
// import infection_control_prevention from '../../assets/track_icons/infection_control_prevention.webp';
// import neurodiversity from '../../assets/track_icons/Neurodiversity.webp';
// import pain_management from '../../assets/track_icons/pain_management.webp';
// import radiology_nursing from '../../assets/track_icons/Radiology_nursing.webp';
// import chronic_disease_management from '../../assets/track_icons/chronic_disease_management.webp';
// import dentistry from '../../assets/track_icons/Dentistry.webp';
// import genetic_disorder from '../../assets/track_icons/genetic_disorder.webp';
// import mental_health_nursing from '../../assets/track_icons/mental_health_nursing.webp';
// import neurological_nursing from '../../assets/track_icons/neurological_nursing.webp';
// // import palliative_care from '../../assets/track_icons/Palliative Care.webp';
// import reproductive_health from '../../assets/track_icons/reproductive_health.webp';

// // EXPORT TRACKS
// export const tracks = [
//   { name: "ADHD", icon: adhd },
//   { name: "Community Nursing", icon: community_nursing },
//   { name: "Emergency & Trauma Nursing", icon: emergency_trauma_nursing },
//   { name: "Geriatric Nursing", icon: geriatric_nursing },
//   { name: "Neonatal Nursing", icon: neonatal_nursing },
//   { name: "Oncology & Cancer Care", icon: oncology_cancer_care },
//   { name: "Pediatric Nursing", icon: pediatric_nursing },
//   { name: "Autism", icon: autism },
//   { name: "Critical Care Nursing", icon: critical_care_nursing },
//   { name: "Epidemiology", icon: epidemiology },
//   { name: "Infection Control & Prevention", icon: infection_control_prevention },
//   { name: "Neurodiversity", icon: neurodiversity },
//   { name: "Pain Management", icon: pain_management },
//   { name: "Radiology Nursing", icon: radiology_nursing },
//   { name: "Chronic Disease Management", icon: chronic_disease_management },
//   { name: "Dentistry", icon: dentistry },
//   { name: "Genetic Disorders", icon: genetic_disorder },
//   { name: "Mental Health Nursing", icon: mental_health_nursing },
//   { name: "Neurological Nursing", icon: neurological_nursing },
//   // { name: "Palliative Care", icon: palliative_care },
//   { name: "Reproductive Health", icon: reproductive_health }
// ];

import clinical_pathology from '../../assets/track_icons/Clinical-Pathology.webp';
import clinical_research from '../../assets/track_icons/Clinical-Research.webp';
import curative_therapeutics from '../../assets/track_icons/Curative-Therapeutics.webp';
import drug_designing from '../../assets/track_icons/Drug-Designing.webp';
import pharma_analysis from "../../assets/track_icons/Pharma-Analysis.webp";
import pharma_biotechnology from "../../assets/track_icons/Pharma-Biotechnology.webp";
import pharmaceutics from "../../assets/track_icons/Pharmaceutics.webp";
import pharma_chemistry from "../../assets/track_icons/Pharma-Chemistry.webp";
import pharmaco_economics from "../../assets/track_icons/Pharmaco-Economics.webp";
import pharmaco_epidomology from "../../assets/track_icons/Pharmaco-Epidomology.webp";
import pharmacognosy from "../../assets/track_icons/Pharmacognosy.webp";
import phytotherapy from "../../assets/track_icons/phytotherapy.webp";
import pharmacology from "../../assets/track_icons/Pharmacology.webp";
import pharmaco_therapeutics from "../../assets/track_icons/Pharmaco-Therapeutics.webp";
import pharma_ethics from "../../assets/track_icons/Pharma-Ethics.webp";
import pharma_regulatory_affairs from "../../assets/track_icons/Pharma-Regulatory-Affairs.webp";
import precision_medicine from "../../assets/track_icons/Precision-Medicine.webp";
import traditional_medicine from "../../assets/track_icons/Traditional-Medicine.webp";
import gene_therapy from "../../assets/track_icons/Gene-Therapy.webp";
import digital_health from "../../assets/track_icons/Digital-Health.webp";

export const tracks = [
  { name: "Pharma Analysis", icon: pharma_analysis },
  { name: "Pharma Biotechnology", icon: pharma_biotechnology },
  { name: "Pharmaceutics", icon: pharmaceutics },
  { name: "Pharma Chemistry", icon: pharma_chemistry },
  { name: "Pharmacoeconomics", icon: pharmaco_economics },
  { name: "Pharmacoepidemiology", icon: pharmaco_epidomology },
  { name: "Pharmacognosy", icon: pharmacognosy },
  { name: "Pharmacology", icon: pharmacology },
  { name: "Pharmaco-Therapeutics", icon: pharmaco_therapeutics },
  { name: "Pharma Ethics", icon: pharma_ethics },
  { name: "Pharma Regulatory Affairs", icon: pharma_regulatory_affairs },
  { name: "Precision Medicine", icon: precision_medicine },
  { name: "Traditional Medicine", icon: traditional_medicine },
  { name: "Clinical Research", icon: clinical_research },
  { name: "Drug Designing", icon: drug_designing },
  { name: "Clinical Pathology", icon: clinical_pathology },
  { name: "Curative Therapeutics", icon: curative_therapeutics },
  { name: "Gene Therapy", icon: gene_therapy },
  { name: "Digital Health", icon: digital_health },
  { name: "Phytotherapy", icon: phytotherapy },
];